export default "__VITE_ASSET__aa09c238__"